import React from "react";
import { HashLink } from "react-router-hash-link";
import "./specialities.scss";

const CARDS = [
  [
    {
      title: "AI Engineering",
      body: "Agents, LLM integrations, and AI-native products. Built with evals and guardrails to hold up in production.",
      icon: "/assets/figma/icon-ai.svg",
    },
    {
      title: "Cloud & Infrastructure",
      body: "From Kubernetes and CI/CD to autoscaling and observability. Infrastructure designed to stay up, scale on demand, and keep costs predictable.",
      bars: true,
    },
  ],
  [
    {
      title: "Mobile Development",
      body: "Native and cross-platform apps built for retention, and engineered to pass store review the first time.",
      icon: "/assets/figma/icon-mobile.svg",
    },
    {
      title: "Web Development",
      body: "From marketing sites to full platforms. Modern stacks, clean architecture, performance measured in milliseconds.",
      icon: "/assets/figma/icon-web.svg",
    },
  ],
];

const Specialities = () => {
  return (
    <section id="specialties" className="mz-special mz-grid">
      <div className="mz-wrap mz-special__inner">
        <div className="mz-special__header">
          <div className="mz-chip">OUR SPECIALTIES</div>
          <div className="mz-special__heading">
            <h2 className="mz-special__title">What we build</h2>
            <p className="mz-special__lead">
              Four disciplines, one standard: design and engineering that ship to production.
            </p>
          </div>
        </div>
        <div className="mz-special__grid">
          {CARDS.map((row, i) => (
            <div key={i} className="mz-special__row">
              {row.map((card) => (
                <article key={card.title} className="mz-card">
                  <span className="mz-card__edge" />
                  <div className="mz-card__top">
                    {card.bars ? (
                      <div className="mz-card__icon mz-card__icon--bars" aria-hidden>
                        <i /><i /><i />
                      </div>
                    ) : (
                      <div className="mz-card__icon">
                        <img src={card.icon} alt="" />
                      </div>
                    )}
                    <div className="mz-card__copy">
                      <h3 className="mz-card__name">{card.title}</h3>
                      <p className="mz-card__body">{card.body}</p>
                    </div>
                  </div>
                  <HashLink to="/#contact" className="mz-card__more">
                    Learn more <span className="arrow">→</span>
                  </HashLink>
                </article>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Specialities;
